<script>
  import {onMount} from 'svelte'
  import gsap from 'gsap'
  import {media} from 'svelte-match-media'
  import AnimatedTitle from '../components/AnimatedTitle.svelte'
  import AnimatedLine from '../components/AnimatedLine.svelte'
  import AnimatedBlock from '../components/AnimatedBlock.svelte'

  import Dish from '../svgs/Dish.svelte'
  import Fios from '../svgs/Fios.svelte'
  import Xumo from '../svgs/Xumo.svelte'
  import Hulu from '../svgs/Hulu.svelte'
  import Tubi from '../svgs/Tubi.svelte'
  import Sling from '../svgs/Sling.svelte'
  import Discovery from '../svgs/Discovery.svelte'
  import AMC from '../svgs/AMC.svelte'
  import Disney from '../svgs/Disney.svelte'
  import ESPN from '../svgs/ESPN.svelte'
  import Viacom from '../svgs/Viacom.svelte'
  import NBC from '../svgs/NBC.svelte'
  import CW from '../svgs/CW.svelte'
  import Pluto from '../svgs/Pluto.svelte'
  import AE from '../svgs/AE.svelte'
  import Univision from '../svgs/Univision.svelte'
  import PlusMore from '../svgs/PlusMore.svelte'

  export let title
  export let subtitle
  export let hasDSP = false
  let section

  onMount(() => {
    section.querySelectorAll('.icon').forEach(icon => {
      gsap.from(icon, {
        opacity: 0,
        y: 30,
        ease: 'power2.out',
        duration: 0.75,
        scrollTrigger: {
          trigger: icon,
          start: 'top 70%',
          end: '+=100',
          toggleActions: 'play play play pause'
        }
      })
    })
  })

</script>

<section class="part5" bind:this={section}>
  <div class="rgrid-md-2-3">
    <div class="col">
      <AnimatedTitle class="large">{@html title}</AnimatedTitle>
      <AnimatedBlock>
        <p class="subtitle1">{@html subtitle}</p>
      </AnimatedBlock>
    </div>
  </div>
  <div class:rgrid-md-2-3={hasDSP} class:has-dsp={hasDSP}>
    <div class="col networks">
      <AnimatedLine class="hline1" />
      <AnimatedBlock>
        <p class="subtitle subtitle2"><strong class="accent">100+</strong> networks, channels, and publishers, plus live events</p>
      </AnimatedBlock>
      <div class="icons">
        <div class="icon" data-name="viacom"><Viacom /></div>
        <div class="icon" data-name="discovery"><Discovery /></div>
        <div class="icon" data-name="espn"><ESPN /></div>
        <div class="icon" data-name="pluto"><Pluto /></div>
        <div class="icon" data-name="nbc"><NBC /></div>
        <div class="icon" data-name="xumo"><Xumo /></div>
        <div class="icon" data-name="disney"><Disney /></div>
        <div class="icon" data-name="hulu"><Hulu /></div>
        <div class="icon" data-name="cw"><CW /></div>
        <div class="icon" data-name="amc"><AMC /></div>
        <div class="icon" data-name="sling"><Sling /></div>
        <div class="icon" data-name="tubi"><Tubi /></div>
        <div class="icon" data-name="ae"><AE /></div>
        <div class="icon" data-name="univision"><Univision /></div>
        <div class="icon plus-more" data-name="plus"><PlusMore /></div>
      </div>
      {#if $media.desktop}
        <AnimatedLine class="hline2" />
      {/if}
    </div>
    {#if hasDSP}
    <div class="col only-dsp">
      <AnimatedLine size={3} desktopSize={5} color="red" class="hline3" />
      <AnimatedBlock>
        <p class="subtitle subtitle3">Only DSP with live linear HH Addressable</p>
      </AnimatedBlock>
      <div class="icons">
        <div class="icon" data-name="dish"><Dish /></div>
        <div class="icon" data-name="fios"><Fios /></div>
      </div>
      <AnimatedLine size={1} color="red" class="hline4" />
    </div>
    {/if}
  </div>
</section>

<style>
  .icons {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px var(--gutter-sm);
    align-items: center;
    padding: 30px 0 50px;
  }
  .icon {
    display: flex;
    justify-content: center;
  }
  .only-dsp :global(.title) {
    font-weight: 500;
  }
  .part5 :global(.hline1) {
    margin: 0 0 2px;
  }
  .part5 :global(.subtitle1) {
    font-weight: 500;
    margin-bottom: 2.5rem;
  }
  .part5 :global(.subtitle) {
    font-size: 0.875rem
  }
  .part5 :global(.subtitle3) {
    font-weight: 500;
  }
  .plus-more {
    display: none;
  }
  @media(min-width: 768px) {
    .networks .icons {
      grid-template-columns: repeat(3, 1fr);
    }
    .plus-more {
      display: flex;
    }
    .part5 :global(.subtitle) {
      font-size: 1rem;
    }
  }
  @media(min-width: 1024px) {
    .networks .icons {
      grid-template-columns: repeat(5, 1fr);
    }
    .networks,
    .only-dsp {
      display: grid;
      position: relative;
      align-content: start;
    }
    .networks :global(.hline2),
    .only-dsp :global(.hline4) {
      position: absolute;
      bottom: 0;
      width: 100%;
    }
  }
</style>